import { MemoizedSelector, MemoizedSelectorWithProps, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import {
  EntriesState,
  PaginationState,
  SearchPageResultState,
  SearchState,
} from '../../../../core/features/store/base-feature-state';
import { DeliveryAddress, Pagination } from '../../../../core/model';
import { PyStateUtils } from '../../../../core/state';
import { DeliveryAddressSearchParamsState, DeliveryAddressState, SoldToState, StateWithSoldTo } from '../sold-to-state';
import { getSoldToState } from './feature.selector';

export const getDeliveryAddressState: MemoizedSelector<StateWithSoldTo, DeliveryAddressState> = createSelector(
  getSoldToState,
  (state: SoldToState) => state && state.deliveryAddresses
);

export const getSearchResultEntities: MemoizedSelector<StateWithSoldTo, EntriesState<DeliveryAddress> | undefined> =
  createSelector(getDeliveryAddressState, (state: DeliveryAddressState) => (state && state.entities) || undefined);

export const getSearchParamsSelector: MemoizedSelector<StateWithSoldTo, DeliveryAddressSearchParamsState> = createSelector(
  getDeliveryAddressState,
  (state: DeliveryAddressState) => (state && state.searchParams) || undefined
);

export const getSearchSelector: MemoizedSelector<StateWithSoldTo, SearchState<SearchPageResultState> | undefined> =
  createSelector(getDeliveryAddressState, (state: DeliveryAddressState) => (state && state.search) || undefined);

export const getSearchPaginationStateSelector: MemoizedSelector<
  StateWithSoldTo,
  PaginationState<SearchPageResultState> | undefined
> = createSelector(
  getSearchSelector,
  getSearchParamsSelector,
  (state: SearchState<SearchPageResultState>, searchParams: DeliveryAddressSearchParamsState) => {
    return (searchParams && state && state[searchParams.key]) || undefined;
  }
);

export const getSearchPageResultsSelector: MemoizedSelector<
  StateWithSoldTo,
  StateUtils.LoaderState<SearchPageResultState>
> = createSelector(
  getSearchParamsSelector,
  getSearchPaginationStateSelector,
  (queryParams: DeliveryAddressSearchParamsState, paginationState: PaginationState<SearchPageResultState>) => {
    return (
      (queryParams && paginationState && paginationState.pages && paginationState.pages[queryParams.page]) ||
      PyStateUtils.initialLoaderState
    );
  }
);

export const getSearchPaginationSelector: MemoizedSelector<StateWithSoldTo, Pagination | undefined> = createSelector(
  getSearchPaginationStateSelector,
  (state) => (state && state.pagination) || undefined
);

export const getSearchResultEntries: MemoizedSelectorWithProps<StateWithSoldTo, any, DeliveryAddress[] | undefined> =
  createSelector(getSearchResultEntities, (entries: EntriesState<DeliveryAddress>, props) => {
    return (props.keys && entries && props.keys.map((i) => entries[i])) || undefined;
  });
